module.exports = __webpack_public_path__ + "media/images/antinblanc-8d051f10.png";